/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum DescriptionAttributeForItsmSecurityAlert {
    tenant_name = 'tenant_name',
    service_account_name = 'service_account_name',
    service_name = 'service_name',
    account_id = 'account_id',
    findings_type = 'findings_type',
    severity = 'severity',
    status = 'status',
    alert_description = 'alert_description',
    intent = 'intent',
    affected_resource = 'affected_resource',
    count = 'count',
    resource_type = 'resource_type',
    resource_id = 'resource_id',
    resource_name = 'resource_name',
    resource_group = 'resource_group',
    subscription_name = 'subscription_name',
    location = 'location'
}
